import type { OptionItem } from 'components/FormSelect';
import { printf } from 'utils/i18n';

export const tradeYear: string[] = ['0 - 1', '2', '3', '4', '5', '6 - 10', __('More than 10')];
export const tradeYearOptions: OptionItem[] = tradeYear.map((item, index) => ({
    value: index + 1,
    label: item
}));

export const tradeNumber: Array<{
    value: number;
    trades: string;
}> = [
    {
        value: 11,
        trades: __('0-10 Trades per Year')
    },
    {
        value: 12,
        trades: __('11-25 Trades per Year')
    },
    {
        value: 13,
        trades: __('26-50 Trades per Year')
    },
    {
        value: 14,
        trades: __('51-100 Trades per Year')
    },
    {
        value: 15,
        trades: __('>100 Trades per Year')
    }
];
export const tradeLevel: string[] = [__('Limited'), __('Good'), __('Excellent')];
export const getMaxMessage = (type: string) => {
    return printf(
        __(`Your %s investment experience does not match your age. Please check the value you entered and try again.`),
        type
    );
};
export const getMinMessage = (type: string) => {
    return printf(__(`Knowledge level required to be above limit in order to perform %s trading.`), type);
};

export const getMinTradeMessage = (type: string = __('option')) => {
    return printf(
        __('Applicant needs to have at least 2 years of trading experience in order to obtain %s trading privileges'),
        type
    );
};
